/**
 * Created by nijin on 20/12/16.
 */
import {Component, OnInit, ViewChild} from '@angular/core';
import {WizardComponent} from './shared/wizard/wizard.component';
import {ActivatedRoute, Params} from '@angular/router';
import {ThingsService} from './things.service';
import {Title} from '@angular/platform-browser';
import {GlobalService} from '../global/global.service';

@Component({
    selector: 'nuc-things-form',
    templateUrl: './things-form.component.html',
    styles: [
      `.thingsFormComponents{
      	padding-left: 280px;
      	position: relative;
        padding-top: 97px;
      	}
      .thingsFormComponents.finalStep{
        padding: 0;
      }
      .hideWizard > .wizard{
         display: none;
      }
      @media (max-width: 767px){
        .thingsFormComponents{
          padding-left: 0px;
          padding-top: 100px;
        }
      }
      `
    ]
})
export class ThingsFormComponent implements OnInit {
   activeStep = 0;
   isAppOnboarding = false;
   isAlreadyMobAdded = true;
   isLoading = false;
  @ViewChild('wizard') wizard: WizardComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private thingService: ThingsService) { }

    ngOnInit() {

      this.activatedRoute.params
        .subscribe((params: Params) => {
          let type = params['device'];
          if (type === 'app') {
            this.isLoading = true;
            this.thingService.getMobileAppDetails()
              .subscribe( (response) => {
                  this.isLoading = false;
                  this.isAlreadyMobAdded = true;
                  this.thingService.updateThingSubject(response.items[0], true);
                },
                (error) => {this.isLoading = false; this.isAlreadyMobAdded = false; });
            this.isAppOnboarding = true;
          } else {
            this.isAlreadyMobAdded = false;
            this.isAppOnboarding = false;
          }

        });
  }
    stepChanged(stepToGo) {
      this.wizard.header.goToNext();
    }






}



// WEBPACK FOOTER //
// ./src/app/things/things-form.component.ts